(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mox-size-guide"] && !Shopify.designMode) return;
  try {
    (function () {
    function initSizeGuides() {
      document.querySelectorAll('.mox-size-guide').forEach(function (details) {
        details.addEventListener('toggle', function () {
          var anyOpen = document.querySelector('.mox-size-guide[open]');
          document.body.style.overflow = anyOpen ? 'hidden' : '';
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSizeGuides);
    } else {
      initSizeGuides();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
